import { eventReady } from './utils';

const Analytics = () => Object.create({

  /**
     * @param eventName
     */
  postSubmissionEvent(eventName, settings) {
    try {
      const event = {
        category: {
          primaryCategory: 'button submission',
        },
        eventInfo: {
          eventName
        },
        myAccount: {
          settings
        }
      };
      eventReady(event);
    } catch (error) {
      console.error('Error during analytics postSubmissionEvent', error);
    }
  },

  /**
     * posts overlay visibility
     * @param eventName
     */
  postOverlayEvent(eventName) {
    try {
      const event = {
        category: {
          primaryCategory: 'overlay',
        },
        eventInfo: {
          eventName
        }
      };
      eventReady(event);
    } catch (error) {
      console.error('Error during analytics postOverlayEvent', error);
    }
  }

});

const analytics = Analytics();

export default analytics;
